export const defaultCustomField = () => {
    return {
        id: null,
        title: "",
        slq_custom_field_nu_gre_id: null,
        is_active: 1
    }
}

export default {
    customFields: [],
    customField: defaultCustomField(),
    action: 'CREATE'
}
